<template>
  <v-dialog v-model="dialog" width="500px">
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase"
        >Thiết lập cho học sinh<v-spacer /> <v-icon color="white" @click="closeDialog">close</v-icon></v-card-title
      >
      <v-divider />
      <v-card-text class="pt-5">
        <CardStudentName :student="$_get(data, 'student')" isShowCurrentClass />
        <div class="mt-3">
          <div>Chiều đi</div>
          <div class="mt-1 black--text text-subtitle-1">
            {{ $_get(data, 'busStop.busSchedule.dayOfWeek', '') | scheduleDay }} -
            {{ $_get(data, 'busStop.busSchedule', {}) | getBusTimeline }}
          </div>
        </div>
        <div class="mt-3">Thiết lập trên tuyến xe</div>
        <div class="d-flex align-center">
          <div class="black--text text-subtitle-1">
            {{ currentIsDefaultAbsent ? 'Có đi' : 'Không đi' }}
          </div>
          <v-icon large class="mx-3">mdi-arrow-right</v-icon>
          <div
            class="text-subtitle-1 font-weight-medium"
            :class="{ 'blue--text': !currentIsDefaultAbsent, 'red--text': currentIsDefaultAbsent }"
          >
            {{ !currentIsDefaultAbsent ? 'Có đi' : 'Không đi' }}
          </div>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn outlined class="ma-2" @click="closeDialog">Hủy</v-btn>
        <v-spacer />
        <v-btn color="primary" class="ma-2 white--text" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { get } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { Student } from '@/plugins/api'
export default {
  components: { CardStudentName },
  data() {
    return {
      dialog: false,
      data: null,
      currentIsDefaultAbsent: null,
      defaultStateItems: [],
    }
  },
  computed: {
    ...mapGetters('constant', ['busTimelines']),
  },
  methods: {
    ...mapActions({
      editStudentDefaultAbsentBusStop: 'busDetail/editStudentDefaultAbsentBusStop',
    }),
    async init({ student = {}, busStop = {} }) {
      const defaultAbsentStudents = get(busStop, 'defaultAbsentStudents', [])
      let currentIsDefaultAbsent = false
      if (Array.isArray(defaultAbsentStudents) && defaultAbsentStudents.length) {
        currentIsDefaultAbsent = !defaultAbsentStudents.includes(student.id)
      } else currentIsDefaultAbsent = true
      this.currentIsDefaultAbsent = currentIsDefaultAbsent
      this.data.student = await Student.fetchOne(student.id, { populates: 'currentClass' })
    },
    async openDialog(data = {}) {
      this.data = data
      await this.init(data)
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.onRefresh()
    },
    onRefresh() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    save() {
      this.$loading.active = true
      try {
        this.editStudentDefaultAbsentBusStop({
          id: get(this.data, 'busStop.id'),
          student: get(this.data, 'student.id'),
          isDefaultAbsent: !this.currentIsDefaultAbsent,
        })
        this.$alert.success('Thiết lập trạng thái mặc định cho học sinh thành công')
        this.closeDialog()
      } catch (error) {
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>
